<template>
    <div class="main">
        <div  class="bg"/>
        <Bar title = "VIP会员尊享内容特权"/>
        <!-- <div class="row"> </div> -->
        <div class="content">
            <van-tabs v-model="active" swipeable animated scrollspy  swipe-threshold="4"  @change="onChange">
                <van-tab>
                    <template #title > 
                    <img class="icon-img" :src="active?icon_default_1:icon_1"/>精品绘本
                    </template>
                    <div class="row"> 
                        <div class="edge-right"></div>
                        <div class="scroll">
                            <img class="img" src="../../assets/images/member_new/ic_benifit_book.png"/>
                            <!-- <div class="bt" @click="jump(1)" v-show="isInApp">
                                <span class="span">立即使用</span>
                            </div> -->
                        </div>
                    </div>
                </van-tab>
                <van-tab>
                    <template #title > <img class="icon-img" :src="active!==1?icon_default_2:icon_2"/>趣味视频</template>
                    <div class="row">
                        <div class="edge-left"></div>
                        <div class="edge-right"></div>
                        <div class="scroll">
                            <img class="img" src="../../assets/images/member_new/ic_benifit_video.png"/>
                            <!-- <div class="bt" @click="jump(2)" v-show="isInApp">
                                <span class="span">立即使用</span>
                            </div> -->
                        </div>
                    </div>
                </van-tab>
                <van-tab>
                    <template #title > <img class="icon-img" :src="active!==2?icon_default_3:icon_3" />海量音频</template>
                     <div class="row">
                        <div class="edge-left"></div>
                        <div class="edge-right"></div>
                        <div class="scroll">
                            <img class="img" src="../../assets/images/member_new/ic_benifit_audio.png"/>
                            <!-- <div class="bt" @click="jump(3)" v-show="isInApp">
                                <span class="span">立即使用</span>
                            </div> -->
                        </div>
                    </div>
                </van-tab>
                <!-- <van-tab>
                    <template #title > <img class="icon-img" :src="icon_11" />课本点读</template>
                   <div class="row">
                        <div class="edge-left"></div>
                        <div class="edge-right"></div>
                        <div class="scroll">
                            <img class="img" src="../../assets/images/member_new/ic_benifits_dotread.png"/>
                            <div class="bt" @click="jump(11)" v-show="isInApp">
                                <span class="span">立即使用</span>
                            </div>
                        </div>
                    </div>
                </van-tab> -->
                <van-tab>
                    <template #title > <img class="icon-img" :src="active!==3?icon_default_4:icon_4" />同步练</template>
                   <div class="row">
                        <div class="edge-left"></div>
                        <div class="edge-right"></div>
                        <div class="scroll">
                            <img class="img" src="../../assets/images/member_new/ic_benifit_exercise.png"/>
                            <!-- <div class="bt" @click="jump(4)" v-show="isInApp">
                                <span class="span">立即使用</span>
                            </div> -->
                        </div>
                    </div>
                </van-tab>
                 <van-tab>
                    <template #title > <img class="icon-img" :src="active!==4?icon_default_5:icon_5" />速算闯关</template>
                    <div class="row">
                        <div class="edge-left"></div>
                        <div class="edge-right"></div>
                        <div class="scroll">
                            <img class="img" src="../../assets/images/member_new/ic_benifit_pk.png"/>
                            <!-- <div class="bt" @click="jump(5)" v-show="isInApp">
                                <span class="span">立即使用</span>
                            </div> -->
                        </div>
                    </div>
                </van-tab>
                 <van-tab>
                    <template #title > <img class="icon-img" :src="active!==5?icon_default_6:icon_6" />魔法学院</template>
                    <div class="row">
                        <div class="edge-left"></div>
                        <div class="edge-right"></div>
                        <div class="scroll">
                            <img class="img" src="../../assets/images/member_new/ic_benifit_chollege.png"/>
                            <!-- <div class="bt" @click="jump(6)" v-show="isInApp">
                                <span class="span">立即使用</span>
                            </div> -->
                        </div>
                    </div>
                </van-tab>
                 <van-tab>
                    <template #title > <img class="icon-img" :src="active!==6?icon_default_7:icon_7" />成语学堂</template>
                    <div class="row">
                        <div class="edge-left"></div>
                        <div class="edge-right"></div>
                        <div class="scroll">
                            <img class="img" src="../../assets/images/member_new/ic_benifit_idiom.png"/>
                            <!-- <div class="bt" @click="jump(7)" v-show="isInApp">
                                <span class="span">立即使用</span>
                            </div> -->
                        </div>
                    </div>
                </van-tab>

                <van-tab v-if="Number(version) < 5124">
                    <template #title > <img class="icon-img" :src="active!==7?icon_default_8:icon_8" />学霸计划</template>
                    <div class="row">
                        <div class="edge-left"></div>
                        <div class="edge-right"></div>
                        <div class="scroll">
                            <img class="img" src="../../assets/images/member_new/ic_benifit_study.png"/>
                            <!-- <div class="bt" @click="jump(8)" v-show="isInApp">
                                <span class="span">立即使用</span>
                            </div> -->
                        </div>
                    </div>
                </van-tab>

                 <van-tab>
                    <template #title > <img class="icon-img" :src="Number(version) < 5124?(active!==8?icon_default_9:icon_9):(active!==7?icon_default_9:icon_9)" />双倍学贝奖励</template>
                    <div class="row">
                        <div class="edge-left"></div>
                        <div class="edge-right"></div>
                        <div class="scroll">
                            <img class="img" src="../../assets/images/member_new/ic_benifit_gold.png"/>
                        
                        </div>
                    </div>
                </van-tab>

                <van-tab>
                    <template #title > <img class="icon-img" :src="Number(version) < 5124?(active!==9?icon_default_10:icon_10):(active!==8?icon_default_10:icon_10)" />会员身份标识</template>
                    <div class="row">
                        <div class="edge-left"></div>
                        <div class="scroll">
                            <img class="img" src="../../assets/images/member_new/ic_benifit_member.png"/>
                           
                        </div>
                    </div>
                </van-tab>

            </van-tabs>
            <div class="bottom_button" @click="jump(active)" v-show="(Number(version) < 5124&&isInApp&&active<8)||Number(version) >= 5124&&isInApp&&active<7">
                 <span class="span">立即使用</span>
            </div>
        </div>
        <!-- <Footer 
        :item = info
        title="开通年度会员" 
        btnText="9.9元开通 首月特惠" /> -->

        
    </div>

</template>
<script>
import utils from "@/assets/js/utils";
import Bar from "./member_bar";
import Footer from "./member_footer_new";
import {MOBILE_API} from "@/constants/api";
import {isRunInApp } from "@/utils/env";
export default {
    components:{
        Bar,
        Footer,
    },
    data(){
        return{
            isInApp:isRunInApp(),
            icon_1:require("../../assets/images/member_new/ic_book.png"),
            icon_default_1:require("../../assets/images/member_new/ic_book_default.png"),
            icon_2:require("../../assets/images/member_new/ic_video.png"),
            icon_default_2:require("../../assets/images/member_new/ic_video_default.png"),
            icon_3:require("../../assets/images/member_new/ic_audio.png"),
            icon_default_3:require("../../assets/images/member_new/ic_audio_default.png"),
            icon_4:require("../../assets/images/member_new/ic_exercise.png"),
            icon_default_4:require("../../assets/images/member_new/ic_exercise_default.png"),
            icon_5:require("../../assets/images/member_new/ic_pk.png"),
            icon_default_5:require("../../assets/images/member_new/ic_pk_default.png"),
            icon_6:require("../../assets/images/member_new/ic_college.png"),
            icon_default_6:require("../../assets/images/member_new/ic_college_default.png"),
            icon_7:require("../../assets/images/member_new/ic_idiom.png"),
            icon_default_7:require("../../assets/images/member_new/ic_idiom_default.png"),
            icon_8:require("../../assets/images/member_new/ic_study.png"),
            icon_default_8:require("../../assets/images/member_new/ic_study_default.png"),
            icon_9:require("../../assets/images/member_new/ic_gold.png"),
            icon_default_9:require("../../assets/images/member_new/ic_gold_default.png"),
            icon_10:require("../../assets/images/member_new/ic_member.png"),
            icon_default_10:require("../../assets/images/member_new/ic_member_default.png"),
            icon_11:require("../../assets/images/member_new/ic_dotread.png"),
            active:parseInt(utils.getQueryString('active')),//取到的是字符串，需要转成number
            entry:utils.getQueryString('entry'),
            token:utils.getQueryString("token"),
            version:utils.getQueryString("version"),//5.1.09
            source:utils.getQueryString("source"),
            info: {
                        "discount": 0,
                        "discountPrice": "1.00",// 优惠价
                        "freeDays": 0,
                        "hasPriceCompare": 1,// 是否有价格比对
                        "isGoodPrice": 0,
                        "isPromotion": 1,// 是否有首次开通标识,1是 0否
                        "isPureSign": 1,
                        "isRecommend": 0,// 是否是推荐,1是 0否
                        "isReturnMoney": 0,
                        "originPrice": "35.00",// 原价
                        "productId": "3184",// 产品id
                        "productType": 24,// 会员连续包月
                        "title": "连续包月",// 标题
                }
        }
    },
    mounted(){ 
        this.doLog("hzxx2975")
        this.getActive()

        this.setScroll();
    },
    methods:{
        setScroll(){
             document.body.addEventListener('touchmove', function (e) {
                let scrollTop =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;
                console.log('scrollTop2',scrollTop)
                if(scrollTop <= 0){
                    e.preventDefault() // 阻止默认的处理方式(阻止下拉滑动的效果)
                }
                }, {passive: false}) // passive 参数不能省略，用来兼容ios和android
        },
        getActive(){
        //    if(this.active == 10){
        //         this.active = 3;
        //     }else if(this.active >=3 ){
        //         this.active += 1;
        //     }
        },
        doLog(actionCode){
            console.log(this.entry + ";" + this.active, this.version)
            utils.sendLog(
                {
                    token:this.token,
                    version:this.version,
                    source:this.source,
                    extensionJson:{
                        type:this.active,
                        entry:this.entry
                    }
                },
                actionCode
            )
        },
        onChange(name,title){
            this.doLog("hzxx2975")
        },
        jump(index){
            this.doLog("hzxx2976")
            switch(index){
                case 0:
                    window.location.href = MOBILE_API.SELF_BOOK;
                    break;
                case 1:
                    window.location.href = MOBILE_API.SELF_VIDEO;
                    break;
                case 2:
                    window.location.href = MOBILE_API.SELF_AUDIO;
                    break;
                case 3:
                    window.location.href = MOBILE_API.SYNC_ROOT_LIST;
                    break;
                case 4:
                    window.location.href = MOBILE_API.CALCULATION_EXERCISE;
                    break;
                case 5:
                    window.location.href = MOBILE_API.SELF_COLLEGE;
                    break;
                case 6:
                    window.location.href = MOBILE_API.SELF_IDIOM;
                    break;
                case 7:
                    window.location.href = MOBILE_API.SELF_STUDY;
                    break;
                // case 11:
                //     window.location.href = MOBILE_API.SELF_DOTREAD;
                //     break;

            }
        }

    },
    computed:{
        
    }
} 
</script>
<style lang="scss" scoped>
.main{
    overflow: hidden;
    text-align: center;
}
.bg{
    width: 100%;
    height: calc(2.92rem + constant(safe-area-inset-top));
    height: calc(2.92rem + env(safe-area-inset-top));
    background: #FFFFFF;
}
.content{
    position: absolute;
    // top: 1.24rem ;
    width: 100%;
    top: 1.12rem;
    height: calc(100vh - 1.12rem);
    // top: calc(1.12rem + constant(safe-area-inset-top));
    // top: calc(1.12rem + env(safe-area-inset-top));
    // height: calc(100vh - 1.12rem - constant(safe-area-inset-top));
    // height: calc(100vh - 1.12rem - env(safe-area-inset-top));
    box-sizing: border-box;
    // padding-top: constant(safe-area-inset-top);
    // padding-top:  env(safe-area-inset-bottom);
    .footer{
        position: fixed;
        width: 100%;
        height: 1.74rem;
        background-color: #FFFFFF;
        bottom: constant(safe-area-inset-bottom);
        bottom: env(safe-area-inset-bottom);
        .f-img{
            width: 6.7rem;
            height: .96rem;
            margin: .16rem .4rem .12rem .4rem;
        }
        .f-text{
            font-size: .24rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #8597A6;
            line-height: .34rem;
            text-align: center;
            &>span{
                color: #9D5E43FF;
            }
        }
    }
    .bottom_button{
        display: flex;
        align-items: center;
        // position: absolute;
        // bottom: 0.36rem;
        justify-content: center;/*水平轴居中*/
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background: #ffffff;
        padding: 0.16rem 0.4rem;
        box-sizing: border-box;
        padding-bottom: calc(constant(safe-area-inset-bottom) + 0.16rem);
        padding-bottom: calc(env(safe-area-inset-bottom) + 0.16rem);
        height: calc(constant(safe-area-inset-bottom) + 1.28rem);
        height: calc(env(safe-area-inset-bottom) + 1.28rem);
        box-sizing: border-box;
        .span{
            display: flex;
            justify-content: center;/*水平轴居中*/
            align-items: center;/*垂直轴居中*/
            width: 6.7rem;
            height: 0.96rem;
            background: linear-gradient(90deg, #FFDAB0 0%, #FCB170 100%);
            border-radius: 0.52rem;
            text-align: center;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #7A3104;
            position: relative;
            &::after{
                content: "";
                display: block;
                position: absolute;
                left: 0;
                top: 0;
                width: 1.54rem;
                height: 0.96rem;
                animation: move 2.5s infinite ease-in-out;
                background: url('../../assets/images/member_new/move-light.png') no-repeat;
                background-size: 100% 100%;
            }
        }
    }
    @keyframes move {
        0% {
            left: -20%;
        }
        100% {
            left: 100%;
        }
    }
}

.tab_title{
    width: .150rem;
    text-align: center;
}
.icon-img{
    width: .84rem;
    height: .84rem;
    margin-left: .3rem;
    margin-right: 0.3rem;
    // margin-top: 0.3rem;
    // position: absolute;
    // top: 0;
    // right: 20%;
}
.row{
    display: inline-block;
    // overflow: hidden;
    // min-height: calc(100vh );
    // width: 100%;
    // // background: #FFFFFF;
    // border-radius: .30rem .30rem 0rem 0rem;
    // box-shadow: 0rem -.20rem .24rem 0rem rgba(184,74,0,0.1);
    // position: absolute;
    // top: calc(2.98rem + constant(safe-area-inset-top));
    // top: calc(2.98rem + env(safe-area-inset-top));
    // padding-top: constant(safe-area-inset-top);
    // padding-top:  env(safe-area-inset-top);
}
.scroll{
        margin-top: .4rem;
        padding: 0 0.3rem 0.3rem;
        // overflow: scroll;
        // height: 9.8rem;
        height:calc(100vh  - 5.18rem - env(safe-area-inset-bottom) - env(safe-area-inset-top));
        height:calc(100vh  - 5.18rem - constant(safe-area-inset-bottom) - constant(safe-area-inset-top));
        // height:calc(100vh - 5.5rem);
        width: 6.7rem;
         background: white;
        border-radius: .30rem .30rem .30rem .30rem;
        box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.03);
        margin-left: 0.4rem;
        margin-right: 0.4rem;
        box-sizing: border-box;
        .bt{
            display: none;
        }
    }
.edge-right{
    margin-top: .4rem;
    float: right;
    width: 0.3rem;
    height:calc(100vh  - 5.18rem - env(safe-area-inset-bottom) - env(safe-area-inset-top));
    height:calc(100vh  - 5.18rem - constant(safe-area-inset-bottom) - constant(safe-area-inset-top));
    box-shadow: 0px 0px 0.8rem 0px rgba(0, 0, 0, 0.03);
    border-radius: 0.3rem 0 0  0.3rem;
    background: #ffffff;
}
.edge-left{
    margin-top: .4rem;
    float: left;
    width: 0.3rem;
    height:calc(100vh  - 5.18rem - env(safe-area-inset-bottom) - env(safe-area-inset-top));
    height:calc(100vh  - 5.18rem - constant(safe-area-inset-bottom) - constant(safe-area-inset-top));  background: #FFFFFF;
    box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.03);
    border-radius: 0px 15px 15px 0px;
    background: #ffffff;
}
    .tab-title{
        display: -webkit-box;
          width: 1.44rem;
          margin-right:  0.3rem;
          text-align: center;
          .img{
            width: 0.84rem;
            height: 0.84rem;
          }
          .text{
            font-size: 12px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #3A4961;
            line-height: 17px; 
            }
    }
    .img-bar{
        width: 6.7rem;
        height: 1.06rem;
        margin-bottom: .48rem;
    }
    .img{
        width: 6.1rem;
        height: 8.2rem;
    }
    .img-small-l{
        width: 3.2rem;
        margin-right: .3rem;
        margin-bottom: .24rem;
    }
    .img-small{
        width: 3.2rem;
        margin-bottom: .24rem;
    }

    .doc{
        margin-top: .14rem;
        font-size: .24rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #A2B1BF;
        line-height: .34rem;
        position: relative;
        padding-left: .08rem;
        &:before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 0.32rem;
            height: 0.32rem;
            background: url("../../assets/images/member_new/king_icon.png") 0 0 /
            cover no-repeat;
        }
    }

/deep/.van-tabs--line .van-tabs__wrap{
    height: 1.8rem;
    margin-left: 0.15rem;
    padding-top: 0.18rem;
}
/deep/.van-tabs__nav--line{
    background-color:transparent !important; 
}
/deep/.van-tab{
    // opacity: 0.4;
    text-align: center;
    width: 1.6rem;
    // margin-right: 0.25rem;
}
/deep/.van-tab--active{
    // opacity: 1;
    width: 1.6rem;
    .van-tab__text{
        color: #7a3104;
        &::after{
            content: "";
            display: block;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 0.44rem;
            height: 0.12rem;
            background: linear-gradient(270deg, #FFB461 0%, #FF8F3E 100%);
            border-radius: 6px;
        }
    }
}
/deep/.van-tabs__line{
    width: 0rem;
    height: 0rem;
    background-color: transparent;
    content: url("")
}
/deep/.van-tab__text{
    // margin-top: 0.3rem;
    color: #8597A6;
    // margin-top: 0.18rem;
    padding-bottom: 0.36rem;
    font-size: 0.24rem;
    text-align: center;
    height: 1.62rem;
    position: relative;
    box-sizing: border-box;
}
// /deep/.icon-img[data-v-ed0bc260] {
//     width: .84rem;
//     height: .84rem;
//     position: absolute;
//     top: 0;
// }
/deep/.van-tabs {
    position: relative;
    padding-top: constant(safe-area-inset-top);
    padding-top:  env(safe-area-inset-top);
    height: 100%;
}
/deep/.van-tabs__content--animated {
    overflow: hidden;
    height: calc(100% - 1.8rem);
    // margin-left: 0.4rem;
    // margin-right: 0.4rem;
}

</style>
